//TODO: Melhorar tipagens
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function findComponentElementIdByEvent(event: any): string | null {
  const componentElementId: string =
    event?.target?.lastChild?.ownerDocument?.activeElement?.id || null;
  return componentElementId;
}

export function transformStringIntoHTML(
  htmlString: string,
): ChildNode | Node | null {
  const temporaryDOMElement = document.createElement('div');
  temporaryDOMElement.innerHTML = htmlString;
  return temporaryDOMElement?.firstChild;
}

// TODO: Excluir essa função após terminar de ajustar componentes
export function getParsedData(
  originalListItems: string | object[] | object,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): object[] | object | any {
  if (originalListItems === null) return null;

  if (typeof originalListItems === 'string') {
    return JSON.parse(originalListItems);
  }

  return originalListItems;
}

export function injectCustomFonts(): void {
  const FONT_FACES = `
    @font-face {}
  `;
  const style = document.createElement('style');
  style.appendChild(document.createTextNode(FONT_FACES));

  document.head.append(style);
}

//TODO: Melhorar tipagens
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function checkIsTypingNumber(event: any) {
  const formattedEvent = event || window.event;
  const charCode = formattedEvent.which
    ? formattedEvent.which
    : formattedEvent.keyCode;

  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}

export function transformToReactIcons(icon: string) {
  let newIcon = '';
  const arr = icon.split('-');

  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    newIcon = newIcon + arr[i];
  }

  return newIcon;
}

export const regexToRemoveHtmlTag = /(<([^>]+)>)/gi;

export const scrollTo = (ids: string[]) => {
  let section: HTMLElement | null = null;
  ids.map((id) => {
    section = document.getElementById(id);
    if (section) {
      setTimeout(() => {
        section?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 350);
      return;
    }
  });
  if (!section) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};
